module.exports = __webpack_public_path__ + "img/apoio-cibet.22064c9b.png";